import React, { memo } from 'react';
import { Input } from 'antd';

import { useDebounce } from '@components';
import Border from '../border';

function LeafHeader({
  title,
  isExpand,
  onExpand,
  isEditing,
  order,
  hasArrow = true,
  upDateCollection,
  location,
  handleDelete,
  formChange = () => {},
}) {
  const debouncedUpdateCollection = useDebounce((newTitle) => {
    upDateCollection({
      payload: {
        title: newTitle,
      },
      location,
    });
  }, 300);

  const animationDelay = `${order - 0.5}s`;

  const handleTitleChange = (e) => {
    formChange();
    debouncedUpdateCollection(e.target.value);
  };

  return (
    <div className="leaf-header" onClick={onExpand}>
      <div className="border-mask" />
      <Border
        direction="horizontal"
        quantity={2}
        order={order + 1}
        isShowDragHandle={isEditing}
        handleDelete={handleDelete}
      />
      <div className="title">
        <div className="animation-mask opacity" style={{ animationDelay }} />
        <div className="animation-mask fadeout" style={{ animationDelay }} />
        {hasArrow && !isEditing && (
          <span
            className={`appkiticon icon-${
              isExpand ? 'up' : 'down'
            }-chevron-fill a-font-14`}
          />
        )}
        {isEditing ? (
          <Input
            onChange={handleTitleChange}
            className="leaf-head-title-input"
            defaultValue={title}
            size="small"
            placeholder="User Input"
            maxLength={60}
          />
        ) : (
          title
        )}
      </div>
    </div>
  );
}

export default memo(LeafHeader);
